import { TextField, MenuItem } from "@mui/material";
import { type FC, type ChangeEvent } from "react";

interface SelectWithLabelProps {
    label: string;
    value: string;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    options: { id: string; name: string; }[];
}

export const SelectWithLabel: FC<SelectWithLabelProps> = ({ label, value, onChange, options }) => {
    return (
        <TextField
            select
            variant="outlined"
            label={label}
            value={value}
            onChange={onChange}
            fullWidth
            InputLabelProps={{
                shrink: true,
            }}
            sx={{
                "& .MuiInputBase-root": {
                    borderRadius: "0.9rem",
                },
                "& .MuiInputLabel-root": {
                    fontSize: "0.9rem",
                    color: "rgba(0, 0, 0, 0.7)",
                },
            }}
        >
            {options.map((option) => (
                <MenuItem key={option.id} value={option.name}>
                    {option.name}
                </MenuItem>
            ))}
        </TextField>
    );
};